import React from 'react'
import './index.css'

const index = ({ children, style = {} }) => {
    return <div className="dialog-wrapper">{children}</div>
}

export default index
